
import { Component, Renderer2 } from '@angular/core';
import { SlideLeft, SlideRight } from 'src/app/Util/AnimationUtil';
import { BasePanelSlide } from 'src/app/View/BaseUI/BasePanelSlide';
import { MatDialog } from '@angular/material/dialog';
import { PaymentDetailPanelController } from './PaymentDetailPanelController';


/**
 * PaymentDetailPanelComponent
 * 請求詳細表示パネル
 */
@Component({
	selector: 'app-diagnose-detail-component',
	templateUrl: './PaymentDetailPanelComponent.html',
	styleUrls: ['./PaymentDetailPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class PaymentDetailPanelComponent extends BasePanelSlide {

	// 対となるコントローラー
	public combineCtrl: PaymentDetailPanelController;

	// 親から受け取るデータ
	public targetData: any;
	// 詳細情報
	public detailData: any = {};

	// パネルを閉じたイベント
	public eventClose: any;

	// 領収書データ
	public pdfSrc = null;
	public zoom = 1;


	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog, public render: Renderer2) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// コントローラーの生成
		this.createController(PaymentDetailPanelController);

	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// 請求詳細データ取得
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getPaymentDetailData.bind(this),
			{ view: this, paymentId: this.targetData.id }
		);
		if (!ret) {
			return;
		}
		this.detailData = ret;

		this.log(ret);
		if (this.targetData.receiptId && this.targetData.payFlag !== 0) {
			await this.getFileUri(this.targetData.receiptId);
		}


		// スライドイン表示は自分でやる
		await this.slideIn();

	}

	////////////////////////////////
	// 画面イベント
	/**
	 * onClickClosePanel
	 * パネル閉じるボタン押下
	 */
	public async onClickClosePanel() {

		this.eventClose();
		this.closeSelfView();

	}

	/**
	 * onClickExecPayment
	 * 外部リンクで決済画面を表示する
	 */
	public async onClickExecPayment() {

		// ユーザー情報未登録・クレカ未登録・与信NGの場合にリンク先が表示される
		// すでに登録済みの場合はリダイレクト先に戻ってくる（ここ）

		// スピナー表示
		await this.showSpinnerMainView(this);
		// リンクで決済ページに遷移
		window.location.href = this.targetData.processUrl;
	}

	/**
	 * dispatchStateFontColor
	 * 画面側から呼ばれるメソッド
	 * 決済未完了のデータの文字を赤文字にする。
	 * @param state 決済状態（0：未決済 1：決済済み）
	 * @returns 文字色
	 */
	public dispatchStateFontColor(state: string|number) {

		if (state === '0' || state === 0) {
			return 'red';
		}

		return 'black';

	}

	public async getFileUri(fileInfoId: number) {
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getPdfData.bind(this),
			{ view: this, fileInfoId }
		);
		this.pdfSrc = ret.uri;
	}

	/**
	 * onClickChangeZoom
	 * ズームが変更されたときのイベント
	 * @param zoom ズーム量
	 */
	public onClickChangeZoom(zoom: number) {

		// １桁台を切り捨て
		this.zoom = this.zoom + zoom;

	}

}



